import type ImageUrlBuilder from '@sanity/image-url/lib/types/builder'
import type { SanityImageSource } from '@sanity/image-url/lib/types/types'
import { CreateDataAttributeProps } from 'next-sanity'

import {
  createDataAttrHelper,
  resolveOpenGraphImage as resolveOGImage,
  urlForImage as urlForImageUtil,
} from '@redbrickmedia/brickster-shared/nextjs/utils'

import { dataset, projectId, studioUrl } from '@/sanity/lib/api'

// Create configured utilities
export const urlForImage = (
  source: SanityImageSource | undefined | null,
): ReturnType<typeof ImageUrlBuilder.prototype.image> | undefined => {
  if (!source) return undefined
  return urlForImageUtil(source, { projectId, dataset })
}

export const resolveOpenGraphImage = (
  image: any,
  width = 1200,
  height = 628,
): string | undefined => {
  return resolveOGImage(image, { projectId, dataset }, width, height)
}

type DataAttributeConfig = CreateDataAttributeProps &
  Required<Pick<CreateDataAttributeProps, 'id' | 'type' | 'path'>>

const dataAttrHelper = createDataAttrHelper({
  projectId,
  dataset,
  baseUrl: studioUrl,
})

export function dataAttr(config: DataAttributeConfig) {
  return dataAttrHelper(config)
}
